import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Accommodation = () => {
  const show = false;
  if (show) {

    return (
      <React.Fragment>
        <SEO title="Accommodation | ICSI 2024" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Accommodation"
          content="For Participants"
          contentTwo="Accommodation"
          linkage="/"
        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">
            <h2>
              The accommodation information will be announced later!
            </h2>


          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Accommodation | ICSI 2024" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Accommodation"
          content="For Participants"
          contentTwo="Accommodation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content1">
            <h3>Make reservation at Qinghai Hotel [青海宾馆]  !</h3>
            <div className="space-20"></div>

            <h5>     </h5>


            <br></br>
            <h5>Import Notice:</h5>

            <ol>
              <strong>
                <li>
                  All participants are highly recommended to make a reservation at Qinghai Hotel, as the conference will be held at this hotel, making it more convenient for everyone.
                </li>
              </strong>


              <strong>
                <li>
                  Our ICSI&apos;2024 conference will be held at Qinghai Hotel in Xining, Qinghai Province from August 23 to 26, 2024. As this period coincides with the local peak tourist season, hotel rooms are in short supply, and prices are high during the peak season. To facilitate the efficient and economical participation of delegates for ICSI&apos;2024, our organizing committee has negotiated with the Qinghai Hotel to reserve some rooms for online booking by delegates. The prices are very favorable. Please complete the online booking before July 10th. Otherwise, we cannot guarantee rooms at this contracted price.
                </li>
              </strong>

              <strong>
              </strong>
              <strong>
                <li>
                  If you have any questions, please don&apos;t hesitate to contact us via email or in the WeChat.
                </li>
              </strong>
            </ol>

            <div className="space-40"></div>

            <h5>Room Information:</h5>
            <br></br>
            <b>
              There are two types of negotiated rooms available for this conference. Each room includes two breakfasts at an affordable price, and authors are recommended to book via the Reservation Form below. Due to the limited number of rooms, the reservation deadline is July 21 ,2024.

            </b>
            <br></br>
            <br></br>

            <div className="entry-content">

            <div className="mytable">
            <table>
                <thead>
                  <th>Room Type</th>
                  
                  <th>Contracted price(RMB)</th>
                  
                  <th>Maximum occupancy per room</th>
                  
                  <th>Note</th>
                </thead>
                <tbody>
                  <tr>
                    <td>Deluxe standard room, king bed, Include breakfast<br></br>(高级标间，大床房, 含早)</td>
                    
                    <td>568 per room per day.</td>
                    
                    <td>2</td>
                    
                    <td>Check-in and check-out time: 12:00 AM.<br></br>入住和退房时间：上午12：00.
                    </td>
                  </tr>
                  <tr>
                    <td>Deluxe standard room, twin bed, Include breakfast<br></br>(高级标间，双床房，含早)</td>
                    
                    <td>568 per room per day.</td>
                    
                    <td>2</td>
                    
                    <td>Check-in and check-out time: 12:00 AM.<br></br>入住和退房时间：上午12：00.
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>

             

            </div>

            <div className="double-sub" >

              <a
                className="btn btn-primary  mt-s"
                href={"https://wj.qq.com/s2/14842560/vqkv/"}
              >
                Hotel Reservation!
              </a>

            </div>








            <hr></hr>
            <div className="space-20"></div>

            <h3>About the venue hotel</h3>
            <br></br>
            As one of the most popular luxury hotels in Xining, Qinghai Hotel is located in a prime location in the city and offers you the best quality service. Enjoy more discounts by booking online!
            <br></br>
            <br></br>

            Qinghai Hotel is situated in the center of Xining, with convenient transportation access. The main building stands 78 meters high, with a total construction area of 42,600 square meters, making it one of the most modern high-rise buildings in Qinghai Province. The hotel integrates dining, accommodation, transportation, tourism, shopping, and entertainment, making it an ideal place for tourism, conferences, and business activities in the Xining area. Qinghai Hotel offers various suites and standard rooms, equipped with central air conditioning, sound systems, satellite TV, and direct international and domestic dialing. The rooms are spacious and comfortable, and no matter which type of room you choose, you will enjoy the unique warmth of the hotel.
            <br></br>
            <br></br>

            The hotel has 12 restaurants of different styles, accommodating up to 1,500 people simultaneously. It offers a variety of cuisines, including Chinese and Western flavors and specialties from the north and south of China. It is an ideal venue for hosting various Chinese and Western banquets and cocktail parties. Here, you will feel invigorated and relaxed, and the personalized service will allow you to fully enjoy the ease and pleasure of business travel.
            <br></br>
            <br></br>
            For more information about the hotel, please visit the website: <a className="simple-link" href="http://qinghai.hotelxining.cn//">http://qinghai.hotelxining.cn//</a>
            <br></br>
            <br></br>

            <table>
              <tr>
                <td width='50%'>
                  <img
                    src="./images/venue/hotel1.jpg"
                    alt="hotel1"
                    width="100%"
                  />

                </td>
                <td width='50%'>
                  <img
                    src="./images/venue/hotel2.jpg"
                    alt="hotel2"
                    width="90%"
                  />
                </td>
              </tr>
              <tr>
                <td width='50%'>
                  <img
                    src="./images/venue/hotel3.png"
                    alt="hotel3"
                    width="100%"
                  />

                </td>
                <td width='50%'>
                  <img
                    src="./images/venue/hotel4.jpg"
                    alt="hotel4"
                    width="85%"
                  />
                </td>
              </tr>
            </table>

            <div className="space-40"></div>


            <hr></hr>
            <div className="space-20"></div>



            {/* <h3>Other Recommended Hotels </h3>

            If you are not satisfied with the hotels listed above, you may choose to stay at a hotel near the conference venue on your own. Around the main conference venue, we recommend the following hotels:

            <ol>
              <li>维也纳酒店(深圳大学城店) - Vienna Hotel (Shenzhen University City Store)</li>
              <li>汉庭酒店(深圳西丽地铁站店) - Hanting Hotel (Shenzhen Xili Metro Station)</li>
              <li>深圳南山西丽大学城亚朵酒店 - Atour Hotel (Shenzhen Nanshan Xili University Town)</li>
            </ol> */}





          </div>

          <div>
            {/* <h2>The information is to be announced. </h2> */}

          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Accommodation;
